import request from '../../utils/request';

export function getProjectsList(params) {
  return request({
    url: 'companies',
    method: 'get',
    params,
  });
}

export function getCompanyList() {
  return request.get('/companies/list')
}

export function getProjectsDetail(name) {
  return request({
    url: `companies/${name}`,
    method: 'get',
  });
}
